import React from 'react';
import { createRoot } from 'react-dom/client';
import Parse from 'parse';
import { registerSW } from 'virtual:pwa-register';

import { PARSE_APP_ID, PARSE_JS_KEY, PARSE_URL } from './config/env';
import InitLocale from './locales/_core/initLocale';
import App from './router/App';

import './index.css';
import 'sweetalert2/dist/sweetalert2.min.css';

registerSW({});

Parse.initialize(PARSE_APP_ID, PARSE_JS_KEY);
Parse.serverURL = PARSE_URL;

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <InitLocale>
      <App />
    </InitLocale>
  </React.StrictMode>,
);
